var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"light-box-cross",on:{"click":_vm.closeLightBox}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"light-box-cross__list"},[_c('li'),_c('li')])}]

export { render, staticRenderFns }